import * as R from 'ramda';

export default function TrainingAdminMediaItemDirectiveController(
  $mdDialog,
  $q,
  alerts,
  eduDataService,
  ssDialogService,
  trainingAdminEditMediaDialog
) {
  const vm = this;

  vm.handleEditMediaClick = _handleEditMediaClick;
  vm.handleDeleteMediaClick = _handleDeleteMediaClick;

  function _handleEditMediaClick($event) {
    ssDialogService.dialogs.admin.editTrainingMediaDialog = ssDialogService.alert(
      trainingAdminEditMediaDialog.getOptions($event, {
        topic: vm.topic,
        section: vm.section,
        media: vm.media,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.admin.editTrainingMediaDialog);
  }

  function _handleDeleteMediaClick($event) {
    $mdDialog.show(
      $mdDialog.confirm()
        .title('Confirm Delete Media')
        .textContent('Are you sure you would like to delete this media item?')
        .ariaLabel('Confirm delete media item')
        .targetEvent($event)
        .ok('Yes')
        .cancel('No')
    ).then(_handleConfirmDialogClick);
  }

  function _handleConfirmDialogClick() {
    eduDataService.deleteMedia(
      vm.media.mediaId
    ).then((response) => {
      if (response.data.result === false) {
        alerts.error('Error occurred while deleting media.');
      } else {
        vm.section.medias = R.reject(
          R.propEq(
            'mediaId',
            vm.media.mediaId
          ),
          vm.section.medias
        );
        alerts.success('The media has been deleted successfully.');
      }
    });
  }
}

TrainingAdminMediaItemDirectiveController.$inject = [
  '$mdDialog',
  '$q',
  'alerts',
  'eduDataService',
  'ssDialogService',
  'trainingAdminEditMediaDialog'
];
